import { render, staticRenderFns } from "./BasicSelect.vue?vue&type=template&id=4801100c&"
import script from "./BasicSelect.vue?vue&type=script&lang=js&"
export * from "./BasicSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports